import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const handleHomeClick = (e) => {
    closeMobileMenu();
    if (location.pathname === '/') {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <header className="site-header">
      <div className="header-container">
        <Link to="/" className="logo-section" onClick={handleHomeClick}>
          <img 
            src="/pa-masons-logo.svg" 
            alt="Pennsylvania Masons" 
            className="pa-logo"
          />
          <span className="lodge-name">Muncy Lodge No. 299 F & A.M.</span>
        </Link>
        
        <button 
          className="mobile-menu-toggle"
          onClick={toggleMobileMenu}
          aria-label="Toggle navigation menu"
          aria-expanded={mobileMenuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`main-nav ${mobileMenuOpen ? 'mobile-open' : ''}`}>
          <Link to="/" onClick={handleHomeClick}>Home</Link>
          <Link to="/our-lodge" onClick={closeMobileMenu}>Our Lodge</Link>
          <Link to="/calendar" onClick={closeMobileMenu}>Lodge Calendar</Link>
          <Link to="/store" onClick={closeMobileMenu}>Store</Link>
          <Link to="/contact" onClick={closeMobileMenu}>Contact</Link>
          <a 
            href="https://www.facebook.com/muncylodge299" 
            target="_blank" 
            rel="noopener noreferrer"
            aria-label="Facebook"
            className="nav-social-icon"
            onClick={closeMobileMenu}
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
            </svg>
          </a>
        </nav>
      </div>
    </header>
  );
}

export default Header;
